import React from "react";
import { ArrowRight } from "react-feather";
import { ButtonPrimary, ButtonSecondary } from "../../ui/buttons";
import { ButtonDejarDeMostrar, ProgressBar, StepContainer, StepText, StepTextSpan } from "./styles";

// para activar el tour desde un componente
// import { useTour } from "@reactour/tour";

//   const { setIsOpen } = useTour();

// useEffect(() => {
//   // activa tour
//   if (!isLoading) {
//     const isTourActive = localStorage.getItem("tour");
//     if (!isTourActive || isTourActive !== "true") {
//       setIsOpen(true);
//     }
//   }
// }, [isLoading]);

export function TourSteps(props) {
  const { currentStep, setCurrentStep, setIsOpen, steps } = props;
  const handleVerMasTarde = () => {
    setIsOpen(false);
  };

  const handleNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const handleVerDeNuevo = () => {
    setCurrentStep(0);
  };

  const handleDejarDeMostrar = () => {
    setIsOpen(false);
    localStorage.setItem("tour", "true");
  };

  const handleFinalizar = () => {
    setCurrentStep(0);
    setIsOpen(false);
  };

  return (
    <>
      {currentStep === 0 && (
        <StepContainer>
          <div className="w-100 d-flex justify-content-start ml-3">
            <StepTextSpan> Nuevas actualizaciones</StepTextSpan>
          </div>
          <div className="d-flex flex-column align-items-end w-100 mt-3">
            <div className="d-flex">
              <ButtonSecondary onClick={handleVerMasTarde}>Más tarde</ButtonSecondary>
              <ButtonPrimary onClick={handleNextStep}>
                Ver más <ArrowRight className="ml-2" size={15} />
              </ButtonPrimary>
            </div>
            <ButtonDejarDeMostrar className="mt-3" onClick={handleDejarDeMostrar}>
              ¿Ya las viste? Dejar de mostrar
            </ButtonDejarDeMostrar>
          </div>
        </StepContainer>
      )}

      {currentStep === 1 && (
        <StepContainer>
          <ProgressBar steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />
          <StepText>
            1. En esta sección vas a poder <StepTextSpan>seleccionar el estado</StepTextSpan> de la nota de pedido.
          </StepText>
          <div className="d-flex w-100 justify-content-end mt-3">
            <ButtonSecondary onClick={handleVerMasTarde}>Más tarde</ButtonSecondary>
            <ButtonPrimary onClick={handleNextStep}>
              Siguiente <ArrowRight className="ml-2" size={15} />
            </ButtonPrimary>
          </div>
        </StepContainer>
      )}

      {currentStep === 2 && (
        <StepContainer>
          <ProgressBar steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />
          <StepText>
            2. En esta sección vas a poder <StepTextSpan>ver el detalle</StepTextSpan> de la nota de pedido.
          </StepText>
          <div className="d-flex w-100 justify-content-end mt-3">
            <ButtonSecondary onClick={handleVerMasTarde}>Más tarde</ButtonSecondary>
            <ButtonPrimary onClick={handleNextStep}>
              Siguiente <ArrowRight className="ml-2" size={15} />
            </ButtonPrimary>
          </div>
        </StepContainer>
      )}

      {currentStep === 3 && (
        <StepContainer>
          <ProgressBar steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />
          <StepText>
            3. En esta sección vas a poder <StepTextSpan>ver las fechas</StepTextSpan> de la nota de pedido.
          </StepText>
          <div className="d-flex w-100 justify-content-end mt-3">
            <ButtonSecondary onClick={handleVerMasTarde}>Más tarde</ButtonSecondary>
            <ButtonPrimary onClick={handleNextStep}>
              Siguiente <ArrowRight className="ml-2" size={15} />
            </ButtonPrimary>
          </div>
        </StepContainer>
      )}

      {currentStep === 4 && (
        <StepContainer>
          <ProgressBar steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />
          <StepText>
            4. En esta sección vas a poder <StepTextSpan> ver, filtrar y agregar derivaciones. </StepTextSpan>
          </StepText>
          <div className="d-flex w-100 justify-content-end mt-3">
            <ButtonSecondary onClick={handleVerMasTarde}>Más tarde</ButtonSecondary>
            <ButtonPrimary onClick={handleNextStep}>
              Siguiente <ArrowRight className="ml-2" size={15} />
            </ButtonPrimary>
          </div>
        </StepContainer>
      )}

      {currentStep === 5 && (
        <StepContainer>
          <ProgressBar steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />
          <StepText>
            5. En esta sección vas poder <StepTextSpan> visualizar información sobre los candidatos y cargar nuevos. </StepTextSpan>
          </StepText>
          <div className="d-flex w-100 justify-content-end mt-3">
            <ButtonSecondary onClick={handleVerDeNuevo}>Ver de nuevo</ButtonSecondary>
            <ButtonPrimary onClick={handleFinalizar}>Finalizar</ButtonPrimary>
          </div>
        </StepContainer>
      )}
    </>
  );
}
